import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { useI18n } from 'vue-i18n'
import CheckBoxStandard from '@/design-system/atoms/CheckBoxStandard.vue'
import InfoLabel from '@/design-system/molecules/InfoLabel.vue'
type Emits = {
  (e: 'selectionChanged', checked: boolean)
}
type Props = {
  checked: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardCheckboxFilterOnlyBookable',
  props: {
    checked: { type: Boolean }
  },
  emits: ["selectionChanged"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const emits = __emit

const updateOnlyBookable = (e: any): void => {
  emits('selectionChanged', e.target.checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CheckBoxStandard, {
      checked: _ctx.checked,
      title: _unref(t)('general__text__bookable-rooms'),
      onValueChanged: updateOnlyBookable
    }, null, 8, ["checked", "title"]),
    _createVNode(InfoLabel, {
      size: 'mediumBold',
      info: _unref(t)('general__text__bookable-rooms-info')
    }, null, 8, ["info"])
  ]))
}
}

})